import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=328eb08f&"
import script from "./Msg.vue?vue&type=script&lang=js&"
export * from "./Msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports